import { Localizer } from '../utils/localize.js';

export const skSk = {
    code: 'sk-sk',
    name: 'Slovak',
    dir: 'ltr',

    welcome: 'Vitajte',
    'wj.file.upload.button': 'Vybrať súbor',
    'wj.file.upload.uploaded': 'Nahraných: ',
    'wj.file.upload.from': 'z',
    'wj.stepper.button.next': 'Ďalej',
    'wj.stepper.button.finish': 'Dokončiť',
    'wj.stepper.button.previous': 'Späť',
    'wj.stepper.step': 'Krok',
};

Localizer.registerTranslation(skSk);
